<!-- Page Banner -->
<div class="page-banner-area item-bg3">
    <div class="container">
        <div class="page-banner-content">
            <h2>Register</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Register</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Banner -->

<!-- Register -->
<section class="register-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="register-image">
                    <img src="assets/img/register-form.png" alt="image">
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="register-form">
                    <h2>Register</h2>

                    <form>
                        <div class="form-group mb-3">
                            <label>Username</label>
                            <input type="text" class="form-control" placeholder="Username">
                        </div>

                        <div class="form-group mb-3">
                            <label>Email</label>
                            <input type="email" class="form-control" placeholder="Email">
                        </div>

                        <div class="form-group mb-3">
                            <label>Password</label>
                            <input type="password" class="form-control" placeholder="Password">
                        </div>

                        <p class="description">The password should be at least eight characters long. To make it stronger, use upper and lower case letters, numbers, and symbols like ! " ? $ % ^ & )</p>

                        <button type="submit" class="default-btn">Register</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Register -->